import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import {
  Sheet as VendorSheet,
  SheetTrigger as VendorSheetTrigger,
  SheetClose as VendorSheetClose,
  SheetContent as VendorSheetContent,
  SheetHeader as VendorSheetHeader,
  SheetFooter as VendorSheetFooter,
  SheetTitle as VendorSheetTitle,
  SheetDescription as VendorSheetDescription,
} from '#/modules/commonComponents/shadcn/ui/sheet';

/** ERP 預設掛點（可暫為空；換皮改此常數）。 */
const SHEET_CONTENT_ERP_CLASS = '';
const SHEET_HEADER_ERP_CLASS = '';
const SHEET_FOOTER_ERP_CLASS = '';
const SHEET_TITLE_ERP_CLASS = '';
const SHEET_DESCRIPTION_ERP_CLASS = '';

/**
 * Vendor sheet 動畫 class 使用 `data-[state=open|closed]`，對齊 @radix-ui/react-dialog。
 * Admin 手機選單一律掛 SheetContent，由 Radix Presence 播完 exit 再卸。
 */
const Sheet = VendorSheet;
const SheetTrigger = VendorSheetTrigger;
const SheetClose = VendorSheetClose;

function SheetContent({ className, ...props }) {
  return (
    <VendorSheetContent
      className={cn(SHEET_CONTENT_ERP_CLASS, className)}
      {...props}
    />
  );
}

SheetContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  side: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  showCloseButton: PropTypes.bool,
};

function SheetHeader({ className, ...props }) {
  return (
    <VendorSheetHeader
      className={cn(SHEET_HEADER_ERP_CLASS, className)}
      {...props}
    />
  );
}

SheetHeader.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

function SheetFooter({ className, ...props }) {
  return (
    <VendorSheetFooter
      className={cn(SHEET_FOOTER_ERP_CLASS, className)}
      {...props}
    />
  );
}

SheetFooter.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

function SheetTitle({ className, ...props }) {
  return (
    <VendorSheetTitle
      className={cn(SHEET_TITLE_ERP_CLASS, className)}
      {...props}
    />
  );
}

SheetTitle.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

function SheetDescription({ className, ...props }) {
  return (
    <VendorSheetDescription
      className={cn(SHEET_DESCRIPTION_ERP_CLASS, className)}
      {...props}
    />
  );
}

SheetDescription.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export {
  Sheet,
  SheetTrigger,
  SheetClose,
  SheetContent,
  SheetHeader,
  SheetFooter,
  SheetTitle,
  SheetDescription,
};
